"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.usePriceRange = void 0;
var _checkoutDeliveryContext = require("../contexts/checkoutDeliveryContext");
var _models = require("../models");
var _utils = require("../utils");
const usePriceRange = (param)=>{
    let { isHomeDelivery, lastDeliveryItemMethod, lastDeliveryItemFee } = param;
    const { deliveryMethods, isLoadingDeliveryMethods } = (0, _checkoutDeliveryContext.useCheckoutDeliveryContext)();
    if (Boolean(isLoadingDeliveryMethods) || !deliveryMethods) {
        return {
            minFee: undefined,
            maxFee: undefined
        };
    }
    if (isHomeDelivery) {
        const lastHomeDeliveryFee = lastDeliveryItemMethod === _models.AddressItemDeliveryMethod.Home ? lastDeliveryItemFee : undefined;
        return (0, _utils.getHomeDeliveryFeeRange)(deliveryMethods, lastHomeDeliveryFee);
    }
    const lastPickupPointDeliveryFee = lastDeliveryItemMethod === _models.AddressItemDeliveryMethod.Home ? undefined : lastDeliveryItemFee;
    return (0, _utils.getPickupPointsFeeRange)(deliveryMethods, lastPickupPointDeliveryFee);
};
exports.usePriceRange = usePriceRange;
